/* eslint-disable angular/controller-as */
angular.
module("digiexam").
controller("DxMoveExamController", function MoveExamController(
	$scope,
	dxDialog,
	course,
	dxLocalize
) {
	"use strict";

	$scope.groups = [];
	$scope.selectedGroup = null;
	$scope.loading = true;
	$scope.error = "";

	var courseGetAll = course.getAll();
	courseGetAll.then(function handleResponse(response) {
		$scope.loading = false;
		if (response.faults) {
			$scope.error = dxLocalize.get("ErrorLoadingCourses");
		} else {
			var courses = response.courses || [];
			$scope.selectedGroup = $scope.groups[0];
			courses.forEach(function eachCourse(c) {
				if (!c.externallyManaged) {
					c.groups.forEach(function eachGroup(g) {
						g.parentCourseId = c.id;
						g.parentCourseTitle = c.title;
						$scope.groups.push(g);

						if ($scope.exam.courseId === c.id && $scope.exam.groupId === g.id) {
							$scope.selectedGroup = g;
						}
					});
				}
			});
		}
	});

	$scope.accept = function accept() {
		$scope.error = "";
		var courseId = $scope.selectedGroup.parentCourseId;
		var groupId = $scope.selectedGroup.id;
		$scope.loading = true;
		var promise = $scope.exam.move(courseId, groupId);
		promise.then(function handleResponse(response) {
			$scope.loading = false;
			if (response.faults) {
				$scope.error = dxLocalize.get("FaultMovingExamTryAgainLater");
			} else {
				angular.extend($scope.exam, response);
				$scope.exam.groupTitle = $scope.selectedGroup.title;
				dxDialog.closeMostRecent();
			}
		});
	};

	$scope.cancel = function cancel() {
		dxDialog.closeMostRecent();
	};
});
